import { sendAxiosRequest } from '../../utils/sendRequest';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IPayResponse from '../../../models/responces/IPayResponse';

export interface IApiPayOrdersParams {
  ids: number[];
}
const apiPayOrders = (params: IApiPayOrdersParams) =>
  sendAxiosRequest({
    method: 'post',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'order',
      action: 'pay',
      id: params.ids.join(',')
    }),
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IPayResponse>;
export default apiPayOrders;
